export function initMetrics() {
  const metricCards = document.querySelectorAll('.metric-card');
  const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function animateCounter(element) {
    const targetStr = element.getAttribute('data-target') || '0';
    
    if (mediaQuery.matches) {
      element.textContent = targetStr;
      return;
    }

    // Parse numeric part and prefix/suffix
    const match = targetStr.match(/^([^\d]*)([\d.,]+)(.*)$/);
    if (!match) {
      element.textContent = targetStr;
      return;
    }

    const prefix = match[1] || '';
    const rawNum = parseFloat(match[2].replace(',', '.'));
    const suffix = match[3] || '';
    const decimals = match[2].includes('.') ? match[2].split('.')[1].length : 0;

    let startTime = null;
    const duration = 1600; // ms

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      
      // EaseOutQuart
      const easeProgress = 1 - Math.pow(1 - progress, 4);
      const currentVal = (rawNum * easeProgress).toFixed(decimals);

      element.textContent = `${prefix}${currentVal}${suffix}`;

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        element.textContent = targetStr;
      }
    }

    requestAnimationFrame(step);
  }

  // Trigger counters with IntersectionObserver
  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const numElem = entry.target.querySelector('.metric-number');
        if (numElem && !numElem.classList.contains('counted')) {
          numElem.classList.add('counted');
          animateCounter(numElem);
        }
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 });

  metricCards.forEach(card => observer.observe(card));
}
